module.exports = __webpack_public_path__ + "img/lamp_posts.1df3f7a3.jpg";